// import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './FormSelectField.module.scss';
import { ucFirst } from '../../utils/caseconverters';
import Icon from '../Icon';

const FormSelectField = ({
    label,
    register,
    type,
    name,
    errors,
    helptext,
    options,
    modifiers = [],
}) => {
    const classes = classNames(
        styles['FormSelectField'],
        modifiers.map(
            (modifier) => styles['FormSelectField--' + ucFirst(modifier)] + ' '
        )
    );

    return (
        <div className={classes}>
            <label htmlFor={name} className={styles['FormSelectField__Label']}>
                {label}
                <select
                    id={name}
                    type={type}
                    name={name}
                    defaultValue={''}
                    {...register}
                    className={styles['FormSelectField__Field']}>
                    <option disabled value="">
                        -- Select an option --
                    </option>
                    {options?.map((item, index) => (
                        <option key={index} value={item.value}>
                            {item.label}
                        </option>
                    ))}
                </select>
                <div className={styles['FormSelectField__Chevron']}>
                    <Icon type={'chevron'} />
                </div>
            </label>
            {helptext && (
                <p className={styles['FormSelectField__HelpText']}>
                    {helptext}
                </p>
            )}
            {errors && errors[name]?.type === 'required' && (
                <span className={styles['FormSelectField__Error']}>
                    This field is required
                </span>
            )}
        </div>
    );
};

FormSelectField.propTypes = {};

export default FormSelectField;
